import React from "react";
import Design from "../../../../../optics/components/drawers/templates/features/advanced-tabs/group/designs/Design";
import {
  AdvacedTabsGroupEditorContainer,
  TabsGroupContainer,
  TabsGroupPlaceholder,
} from "./styles";
import { useAdvancedTabsGroupStore } from "../../../../../stores/use-advanced-tabs-group-store";
import { useTranslation } from "react-i18next";

const AdvancedTabsGroupEditor = () => {
  const { data, setData, selectedTab, setSelectedTab } =
    useAdvancedTabsGroupStore((state) => ({
      data: state.data,
      setData: state.setData,
      selectedTab: state.selectedTab,
      setSelectedTab: state.setSelectedTab,
    }));
  const { t } = useTranslation();

  return (
    <AdvacedTabsGroupEditorContainer>
      <TabsGroupContainer>
        <Design data={data} tab={{ selectedTab, setSelectedTab }} />
        <TabsGroupPlaceholder alignment={data.alignment}>
          --- {t("advanced-tabs-content-placeholder")} ---
        </TabsGroupPlaceholder>
      </TabsGroupContainer>
    </AdvacedTabsGroupEditorContainer>
  );
};

export default AdvancedTabsGroupEditor;
